export const COOKIE_CONSENT_KEY = "cookieConsent";
const PAYMENT_ACTIONS = new Set(["opened", "started", "succeeded", "cancelled", "failed"]);

function hasAnalyticsConsent() {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === "accepted";
  } catch (error) {
    return false;
  }
}

function getGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function"
    ? window.gtag
    : null;
}

function sendEvent(eventName, params = {}) {
  const gtag = getGtag();

  if (
    !(
      eventName === "page_view" ||
      eventName === "notification_shown" ||
      eventName === "client_api_error" ||
      eventName === "modal_opened" ||
      eventName === "modal_closed" ||
      eventName.startsWith("payment_checkout_") &&
      PAYMENT_ACTIONS.has(eventName.replace("payment_checkout_", ""))
    ) ||
    !gtag ||
    !hasAnalyticsConsent()
  ) {
    return false;
  }

  gtag("event", eventName, params);
  return true;
}

export function grantAnalyticsConsent() {
  const gtag = getGtag();

  if (gtag) {
    gtag("consent", "update", { analytics_storage: "granted" });
  }
}

export function trackPageView(pathname) {
  return sendEvent("page_view", { page_path: String(pathname).split("?")[0] });
}

export function trackPaymentEvent(action, { packCode, value, currency } = {}) {
  const eventName = `payment_checkout_${action}`;
  const params = {};

  if (packCode) params.pack_code = String(packCode);
  if (Number.isFinite(Number(value))) params.value = Number(value);
  if (currency) params.currency = String(currency).toUpperCase();

  return sendEvent(eventName, params);
}

export function trackModalEvent(action, modal) {
  return sendEvent(`modal_${action}`, { modal: String(modal) });
}

export function trackNotificationShown(type, count) {
  const params = { notification_type: String(type) };

  if (Number.isFinite(Number(count))) params.count = Number(count);

  return sendEvent("notification_shown", params);
}

export function trackClientApiError({ status, method, path } = {}) {
  const params = {};

  if (Number.isFinite(Number(status))) params.status = Number(status);
  if (method) params.method = String(method).toUpperCase();
  if (path) params.path = String(path).split("?")[0];

  return sendEvent("client_api_error", params);
}

export const __analytics = { hasAnalyticsConsent, sendEvent };
